export const startsOnField = (canSeeStartsOn: boolean) => {
  if (canSeeStartsOn) {
    return { starts_on: 'date' }
  }
}

export const endsOnField = (canSeeEndsOn: boolean) => {
  if (canSeeEndsOn) {
    return { ends_on: 'date' }
  }
}

export const hasTrialPeriodField = (canSeeTrialPeriod: boolean) => {
  if (canSeeTrialPeriod) {
    return { has_trial_period: 'boolean' }
  }
}

export const trialPeriodEndDateField = (canSeeTrialPeriodEndDate: boolean) => {
  if (canSeeTrialPeriodEndDate) {
    return { trial_period_ends_on: 'date' }
  }
}

export const jobTitleField = (canSeeJobTitle: boolean) => {
  if (canSeeJobTitle) {
    return { job_title: 'string' }
  }
}

export const salaryFields = (canSeeSalary: boolean) => {
  if (canSeeSalary) {
    return { salary_amount: 'cents', salary_frequency: 'string' }
  }
}

export const workingHoursFields = (canSeeWorkingHours: boolean) => {
  if (canSeeWorkingHours) {
    return {
      working_hours: 'cents',
      working_hours_frequency: 'string',
      working_week_days: 'string',
      max_legal_yearly_hours: 'cents',
      maximum_weekly_hours: 'cents',
      max_work_minutes_per_day: 'cents',
      min_rest_minutes_between_days: 'cents',
    }
  }
}
